import type { Move } from '../../../schemas/move';
import { chiericoArchetypeMoves } from './archetypes';
import {
  chiericoInitialMoves,
  chiericoStartingAutoMoves,
  chiericoStartingChoiceMoves,
} from './initial';
import { chiericoAdvanced2to5Moves } from './advanced-2-5';
import { chiericoAdvanced6to10Moves } from './advanced-6-10';

export {
  chiericoArchetypeMoves,
  chiericoInitialMoves,
  chiericoStartingAutoMoves,
  chiericoStartingChoiceMoves,
  chiericoAdvanced2to5Moves,
  chiericoAdvanced6to10Moves,
};

/**
 * Catalogo completo delle mosse del Chierico (manuale V1, sezione "Il
 * Chierico", rr. 2602-2961).
 *
 * Aggregato di:
 *  - 5 archetipi (`class_special`)
 *  - 4 mosse iniziali automatiche + 3 mosse iniziali di scelta (`starting`,
 *    `pickCount: 1` sul gruppo di scelta)
 *  - 16 mosse avanzate L2-5 (`advanced_2_5`)
 *  - 14 mosse avanzate L6-10 (`advanced_6_10`)
 *
 * Totale: 42 mosse.
 *
 * **Pattern stress-testati per la prima volta in questa classe**:
 *  - Casteggiante con **Tradizioni Sacre** (5: Crepuscolo, Guarigione,
 *    Illuminazione, Negromanzia, Valore) — primo caso di
 *    `SpellcastingConfig.tradizioni` popolato
 *  - Mossa-config *Divinità* con `choices` strutturate sulla Tradizione
 *    Sacra del PG (workaround D2 per Sfera/Fondamento/Nome rimasti in
 *    description; FI-18 li strutturerà in PR dedicata)
 *  - Cross-class restriction `prerequisites.anyOf` con forward-reference
 *    a `druido.divinita-della-natura` e `paladino.ordine-sacro` (pattern
 *    già supportato da FI-19 chiuso col Guerriero)
 */
export const chiericoMoves: readonly Move[] = [
  ...chiericoArchetypeMoves,
  ...chiericoInitialMoves,
  ...chiericoAdvanced2to5Moves,
  ...chiericoAdvanced6to10Moves,
];
